export const SALESTYPE_LOADING = "SALESTYPE_LOADING";
export const SALESTYPE_RESET = "SALESTYPE_RESET";
export const GET_SALESTYPE = "GET_SALESTYPE";
export const GET_SALESTYPE_SUCCESS = "GET_SALESTYPE_SUCCESS";
export const GET_SALESTYPE_FAIL = "GET_SALESTYPE_FAIL";
export const DELETE_SALESTYPE = "DELETE_SALESTYPE"
export const DELETE_SALESTYPE_SUCCESS = "DELETE_SALESTYPE_SUCCESS"
export const DELETE_SALESTYPE_FAIL = "DELETE_SALESTYPE_FAIL"
export const UPDATE_SALESTYPE = "UPDATE_SALESTYPE"
export const UPDATE_SALESTYPE_SUCCESS = "UPDATE_SALESTYPE_SUCCESS"
export const UPDATE_SALESTYPE_FAIL = "UPDATE_SALESTYPE_FAIL"
export const ADD_NEW_SALESTYPE = "ADD_NEW_SALESTYPE"
export const ADD_SALESTYPE_SUCCESS = "ADD_SALESTYPE_SUCCESS"
export const ADD_SALESTYPE_FAIL = "ADD_SALESTYPE_FAIL"